import moment from 'moment'
import Datepicker from '@/components/DatePicker'
import TimePicker from '@/components/TimePicker'
import Modal from '@/components/Modal'
import { defineComponent } from 'vue'

export default defineComponent({
  name: "newDeadline",
  props: {
    hideModal: Function,
    hasFloatingCloseButton: Boolean,
  },
  components: {
    Datepicker,
    TimePicker,
    Modal,
  },
  data() {
    return {
      customFormatterDate: moment().format("MM/DD/YYYY"),
      customFormatterTime: moment().format("hh:mm a"),
      select_time: {
        hours: "",
        minutes: "",
        a: "",
      },
      select_date: {
        days: "",
        months: "",
        years: "",
      },
      tmpTime: "",
      formData: {
        date: null,
        time: null,
      },
      validDate: null,
      errorMsg: {
        notify_before_hour: null,
      },
      isShow: false,
    };
  },
  computed: {
    yesterday() {
      return moment().format("yyyy-MM-DD");
    },
  },
  methods: {
    showModal() {
      this.isShow = true;
    },
    hideObjModal() {
      this.isShow = false;
    },
    hide: function () {
      this.hideModal(this.formData);
    },
  },
  watch: {
    select_date(v) {
      if (v) {
        this.validDate = true;
        this.formData.dateTime = { ...v, ...this.select_time };
      }
    },
    select_time(v) {
      if (v) {
        this.formData.dateTime = { ...this.select_date, ...v };
      }
    },
  },
});